import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ServiceProCookieConsentButtonComponent } from "../../cookie-consent/service-pro-cookie-consent-button.component";

export interface UserInfoData {
    user: {
        initialer?: string;
        name: string;
        email: string;
        phone: string;
    };
    works: {
        name: string;
        address: string;
        phone: string;
    };
}

@Component({
    selector: "user-info",
    imports: [CommonModule, ServiceProCookieConsentButtonComponent],
    templateUrl: "./user-info.html",
    styleUrl: "./user-info.scss"
})
export class UserInfo {
    @Input()
    public data: UserInfoData;
    @Output()
    public close = new EventEmitter<void>();

    public onClose(): void {
        this.close.emit();
    }
}
